import { hydrate, render } from 'preact';
import './styles/global.css';
import { App } from './app';

// The App is prerendered to static HTML (scripts/prerender.mjs at build time, the
// content dev-middleware in `vite dev`) so the homepage paints the editor card with
// a skeleton before any JS runs. #root is the ONLY island that hydrates — the nav,
// hero, and landing around it are static HTML and never hydrate. Hydrate the
// existing markup; fall back to a fresh render if the container is empty (e.g. a
// request that bypassed SSR).
const root = document.getElementById('root');
if (root) {
  if (root.firstChild) hydrate(<App />, root);
  else render(<App />, root);
}

// Core Web Vitals: loaded ONLY when measurement is enabled (`?perf` flag or dev),
// via dynamic import so the production app-shell bundle is unaffected.
if (import.meta.env.DEV || (typeof location !== 'undefined' && /[?&]perf\b/.test(location.search))) {
  void import('./perf/web-vitals').then((m) => m.initWebVitals());
}

// Register the offline Service Worker (built standalone to /sw.js). Registered
// after load so it never competes with the first paint / app-shell download.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* SW is a progressive enhancement; failure leaves the app fully usable online */
    });
  });
}

